import {
  DeleteMemoryAction,
  ListMemoriesAction,
  MEMORIES_ACTION,
  UpdateMemoriesAction,
  UpdateMemoryAction,
} from "./actions";
import { MemoriesState } from "./types";

type MemoryRecord = MemoriesState["items"][string];

type MemoriesActions =
  | ListMemoriesAction
  | UpdateMemoryAction
  | UpdateMemoriesAction
  | DeleteMemoryAction;

const mergeMemory = (
  existing: MemoryRecord | undefined,
  incoming: Partial<MemoryRecord> & { id: string },
): MemoryRecord => {
  return {
    ...existing,
    ...incoming,
    transcript: getNextTranscript(existing, incoming),
  } as MemoryRecord;
};

const getNextTranscript = (
  existing: MemoryRecord | undefined,
  incoming: Partial<MemoryRecord>,
) => {
  if (incoming.is_processing) {
    return incoming.transcript ?? null;
  }
  if (incoming.transcript === undefined || incoming.transcript === null) {
    return existing?.transcript ?? null;
  }
  return incoming.transcript;
};

export const memoriesReducer = (
  state: MemoriesState = {
    items: {},
    hasLoaded: false,
  },
  action: MemoriesActions,
): MemoriesState => {
  switch (action.type) {
    case MEMORIES_ACTION.LIST_MEMORIES_ACTION: {
      const items: MemoriesState["items"] = {};
      for (const memory of action.memories) {
        const existing = state.items[memory.id];
        items[memory.id] = mergeMemory(existing, memory);
      }
      return {
        items,
        hasLoaded: true,
      };
    }
    case MEMORIES_ACTION.UPDATE_MEMORY: {
      const existing = state.items[action.memory.id];
      return {
        ...state,
        items: {
          ...state.items,
          [action.memory.id]: mergeMemory(existing, action.memory),
        },
      };
    }
    case MEMORIES_ACTION.UPDATE_MEMORIES: {
      const nextItems = { ...state.items };
      for (const memory of action.memories) {
        nextItems[memory.id] = mergeMemory(nextItems[memory.id], memory);
      }

      return {
        ...state,
        items: nextItems,
      };
    }
    case MEMORIES_ACTION.DELETE_MEMORY: {
      const nextState = { ...state.items };
      delete nextState[action.memoryId];
      return {
        ...state,
        items: nextState,
      };
    }
    default:
      return state;
  }
};
